import { memo } from 'react';
import StepCSSTransitionGroup from '@wg/wows-react-uikit/components/Animations/StepCSSTransitionGroup';
import ErrorLoad from '@wg/wows-react-uikit/components/ErrorLoad/ErrorLoad';

import { t } from '~/helpers/localization';

interface ClanProfileMessageErrorProps {
  error?: string;
  onReloadClick: () => void;
}

const ClanProfileMessageError = ({ error, onReloadClick }: ClanProfileMessageErrorProps) => (
  <StepCSSTransitionGroup level={1}>
    <ErrorLoad
      isFlat
      key="error-load"
      message={error || t('Произошла ошибка. Повторите попытку позже')}
      onReloadClick={onReloadClick}
    />
  </StepCSSTransitionGroup>
);

export default memo(ClanProfileMessageError);
